<template>
    <searchContainer :searchHandler="search" :resetHandler="reset">
        <template v-slot:items>
            <div class="row">
                <input-number v-model="filters.wallet_id" :options="{ id: 'wallet_id', step: 1, label: 'wallet_id' }"/>
                <input-number v-model="filters.owner_id" :options="{ id: 'owner_id', step: 1, label: 'owner_id' }"/>
                <select-wallet-owner-types v-model="filters.owner_types" :options="{ id: 'wallet_owner_types', label: 'owner_type', placeholder: 'placeholders.all', multiple: true }"/>
            </div>
            <div class="row">
                <input-number v-model="filters.balance_from" :options="{ id: 'balance_from', label: 'balance_from' }"/>
                <input-number v-model="filters.balance_to" :options="{ id: 'balance_to', label: 'balance_to' }"/>
            </div>
        </template>
    </searchContainer>
</template>
<script>

    import {mapGetters} from "vuex";
    import {CRUD_SEARCH_RESET} from "actions/crud";
    import searchContainer from "@/components/crud/card/CardSearch";

    const CRUD_CODE = `wallets`;
    export default {
        name: "WalletSearch",
        components: {
            searchContainer
        },
        props: {
            listHandler: {
                type: Function,
                default: () => {
                }
            },
        },
        data() {
            return {
                transPrefix: CRUD_CODE,
                filters: {
                    owner_id: this.getFilterByKey('owner_id'),
                    owner_types: this.getFilterByKey('owner_types'),
                    balance_from: this.getFilterByKey('balance_from'),
                    balance_to: this.getFilterByKey('balance_to'),
                    wallet_id: this.getFilterByKey('wallet_id'),
                },
                filtersMap: {
                    types: 'ownerTypes',
                    balance_from: 'balanceFrom',
                    balance_to: 'balanceTo',
                    owner_id: 'ownerId',
                    wallet_id: 'walletId',
                }
            }
        },
        mounted() {
            this.setSearchParams(this.filters, this.filtersMap);
        },
        computed: {
            ...mapGetters([
                "getSearchFilters"
            ])
        },
        methods: {
            search() {
                this.resetPagination();
                this.setSearchParams(this.filters, this.filtersMap, {routeParams: this.getFilters(this.filters)});
                this.pushRoute(this.getSearchFilters);
                this.listHandler();
            },
            reset() {
                this.resetPagination();
                this.$store.dispatch(CRUD_SEARCH_RESET);
                this.filters = this.clearFilters(this.filters);
                this.pushRoute();
                this.listHandler();
            },
            resetPagination() {
                //Reset Pagination
                this.$emit('input', 0);
            },
            pushRoute(query = {}) {
                this.$router.push({name: this.$route.name, query}).catch(() => {});
            },
        }
    };
</script>
